<template>
  <div class="cms" :key="JSON.stringify(new Date())">
    <Navbar />
    <div class="container-fluid g-0">
      <div class="row g-0 flex-nowrap">
        <div class="col-auto">
          <Sidebar />
        </div>
        <div
          class="col px-4 d-flex flex-column justify-content-between"
          style="width: 100px"
        >
          <router-view />
          <div class="card text-gray mx-n4">
            <div class="card-body d-flex justify-content-between">
              <div>
                Client： <span class="text-primary">{{ clientName }}</span>
              </div>
              <div>
                Version： <span class="text-primary">{{ version }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/layout/Navbar.vue'
import Sidebar from '@/components/layout/Sidebar.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'UserCms',
  components: { Navbar, Sidebar },
  data () {
    return {
      version: process.env.PACKAGE_VERSION
    }
  },
  computed: {
    ...mapGetters(['clientName'])
  }
}
</script>

<style lang="scss">
.cms {
  background-color: #eef0f8;
  min-height: 100vh;
  > .container-fluid {
    position: relative;
  }
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 300px;
    background: linear-gradient(90deg, #0053cd 0%, #15a794 100%);
    z-index: 0;
  }
}
</style>
